import ReactDOM from 'react-dom';
import {get} from 'lodash';
import API from 'modules/legacy/js/lib/api';
import {recaptchaSiteKey} from 'config/app';

module.exports = {
  captchaReference: null,

  componentDidMount() {
    if (typeof window.grecaptcha !== 'undefined') {
      this.updateReCaptchaWidget();
    }
  },

  updateReCaptchaWidget() {
    var component = this;
    var grecaptcha = window.grecaptcha;

    API.getCaptcha(function getCaptcha(error, res) {
      if (error) return console.error(error);

      if (!get(res, 'required', null)) return false;

      if (component.captchaReference !== null) {
        grecaptcha.reset(component.captchaReference);
        ReactDOM.findDOMNode(component.refs.recaptcha).style.display = '';
        return false;
      }

      component.captchaReference = grecaptcha.render('recaptcha', {
        sitekey: recaptchaSiteKey,
        theme: 'light',
        callback: function callback(resGetCallback) {
          API.postCaptcha({response: resGetCallback}, function postCaptcha(err, response) {
            if (err) return console.error(err);
            if (response.success === true) {
              ReactDOM.findDOMNode(component.refs.recaptcha).innerHTML = '';
              return ReactDOM.findDOMNode(component.refs.recaptcha).innerHTML;
            }
          });
        }
      });
    });
  }
};
